import React, { Component } from 'react';
import config from 'react-global-configuration';
import RequestApi from '../../Miscelania/RequestApi';

// Helpers de formulário
import InputMask from 'react-input-mask';
import Toggle from 'react-toggle';
import Select from 'react-select';

// Importo o moment com a linguagem pt-br
require('moment');
require('moment/locale/pt-br');

class AircraftLogbookFlightsTab extends Component {
    constructor(props) {
        super(props);
    
        this.state = {
          overlay: {
            message: '',
            type: '',
            status: 'closed',
          },
          redirect_url: false,
          loaded: 0,
          aircraft_logbook_id: this.props.aircraft_logbook_id,
          aircraft: {},
          approvals: [],
          flight_reports_list: [],
          flights: {},
          aircraft_model_version_custom_items: {},
        };
        this.add = this.add.bind(this);
      }

      // Handlers
      handleChange (name, event) {
        var change = {};
        change[name] = event.target.value;
        this.setState(change);
      }
    
      handleSelectChange(name, event) {
        var change = {};
        if(event == null) {
          change[name] = null;
        } else {
          change[name] = event.value;
        }
        this.setState(change);
      }

      // LM
      componentWillReceiveProps(newProps) {
        if(this.state.loaded === 0) {
          this.setState({
            aircraft_logbook_id: newProps.aircraft_logbook_id,
            loaded: 1,
          });
        }

        if(typeof newProps.aircraft !== 'undefined' && newProps.aircraft !== null && this.state.loaded === 1) {
          this.setState({
            aircraft_logbook_id: newProps.aircraft_logbook_id,
            aircraft: newProps.aircraft,
          });
        }

        if(typeof newProps.flights !== 'undefined' && newProps.flights !== null && this.state.loaded === 1) {
          this.setState({
            aircraft_logbook_id: newProps.aircraft_logbook_id,
            flights: newProps.flights,
          });
        }

        if(typeof newProps.aircraft_model_version_custom_items !== 'undefined' && newProps.aircraft_model_version_custom_items !== null && this.state.loaded === 1) {
          this.setState({
            aircraft_logbook_id: newProps.aircraft_logbook_id,
            aircraft_model_version_custom_items: newProps.aircraft_model_version_custom_items,
          });
        }

        if(typeof newProps.flight_reports_list !== 'undefined' && newProps.flight_reports_list !== null && this.state.loaded === 1) {
          this.setState({
            aircraft_logbook_id: newProps.aircraft_logbook_id,
            flight_reports_list: newProps.flight_reports_list,
          });
        }

        if(typeof newProps.approvals[4] !== 'undefined' && newProps.approvals[4] !== null && this.state.loaded === 1) {
          this.setState({
            aircraft_logbook_id: newProps.aircraft_logbook_id,
            approvals: newProps.approvals[4],
          });
        }
      }
    
      // Fetch cadastrando o voo
      add(event) {
        event.preventDefault();
        this.props.handleAlert('', '', 'open');
        var datasave = {
          aircraft_logbook_id: this.state.aircraft_logbook_id,
          flight_report_id: this.state.flight_report_id,
        };
        var header = this.refs.request_api.header('application/json');
        var self = this;
        var url = '/aeronave/diario/voos';
        Promise.resolve(header).then(function(value) {
          fetch(config.get('api') + url, { method: 'POST', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
            self.refs.request_api.validate(responseJson, 'alert');
            self.props.updateData(responseJson);
            self.setState({
              flight_report_id: '',
            });
          }).catch((error) => {
            console.error(error);
          });
        });
      }
    
      render() {
        var self = this;
        return (
      <div>
        <RequestApi ref={'request_api'} />
        <h3 className="page-title pull-left">Flights</h3>
        <div className="clearfix"></div>
        <hr/>
        {/* <form onSubmit={this.add}>
          <div className="row">
            <div className="col-md-5">
              <div className="form-group">
                <label>Flight Report</label>
                <Select
                  className="form-group"
                  name="flight_report_id"
                  value={this.state.flight_report_id}
                  searchable={true}
                  placeholder={'Selecionar relatório'}
                  onChange={this.handleSelectChange.bind(this, 'flight_report_id')}
                  options={this.state.flight_reports_list}
                  required
                />
              </div>
            </div>
            <div className="col-md-3">
              <div className="form-group">
                <button type="submit" className="btn btn-inline btn-block btn-primary"><i className="fa fa-fw fa-save"></i> Cadastrar</button>
              </div>
            </div>
          </div>
        </form>
        <hr/> */}
        <div className="table-responsive">
          <table className="table table-bordered table-hover table-striped">
            <thead>
              <tr>
                <th rowSpan={2} className="text-center vcenter">ST</th>
                <th rowSpan={2} className="text-center vcenter">RV</th>
                <th rowSpan={2} className="text-center vcenter">FROM</th>
                <th rowSpan={2} className="text-center vcenter">TO</th>
                <th rowSpan={2} className="text-center vcenter">START</th>
                <th rowSpan={2} className="text-center vcenter">TAKE OFF</th>
                <th rowSpan={2} className="text-center vcenter">LANDING</th>
                <th rowSpan={2} className="text-center vcenter">SHUTDOWN</th>
                <th rowSpan={2} className="text-center vcenter">NIGHT TIME</th>
                <th rowSpan={2} className="text-center vcenter">IFR</th>
                <th rowSpan={2} className="text-center vcenter">LDG</th>
                <th rowSpan={2} className="text-center vcenter">TOTAL TO-LDG</th>
                <th rowSpan={2} className="text-center vcenter">TOTAL ST/SHT</th>
                <th rowSpan={2} className="text-center vcenter">START FUEL</th>
                <th rowSpan={2} className="text-center vcenter">FINAL FUEL</th>
                <th rowSpan={2} className="text-center vcenter">POB</th>
                <th rowSpan={2} className="text-center vcenter">CARGO</th>
                <th colSpan={2} className="text-center vcenter">HOOK OPER</th>
                <th rowSpan={2} className="text-center vcenter">FLIGHT TYPE</th>
                {Object.keys(self.state.aircraft_model_version_custom_items).length > 0 ?
                  <th colSpan={Object.keys(self.state.aircraft_model_version_custom_items).length} className="text-center vcenter">CUSTOM ITEMS</th>
                  : ''
                }
                {
                  (self.state.aircraft.hums == 1) ?
                  <th colSpan={2} className="text-center vcenter">HUMS ALERTS</th>
                  :
                  ''
                }
              </tr>
              <tr>
                <th className="text-center vcenter">HRS</th>
                <th className="text-center vcenter">CYC</th>
                {Object.keys(self.state.aircraft_model_version_custom_items).length > 0 ?
                  Object.keys(self.state.aircraft_model_version_custom_items).map(function(k) {
                    var custom_item = self.state.aircraft_model_version_custom_items[k];
                    return(
                      <th className="text-center vcenter">{custom_item.name}</th>
                    );
                  })
                  :
                  ''
                }
                {
                  (self.state.aircraft.hums == 1) ?
                  <th className="text-center vcenter">STATUS</th>
                  :
                  ''
                }
                {
                  (self.state.aircraft.hums == 1) ?
                  <th className="text-center vcenter">CONFIRMED</th>
                  :
                  ''
                }
              </tr>
            </thead>
            <tbody>
              {Object.keys(self.state.flights).map(function(k)
              {
                var flight = self.state.flights[k];
                return(
                  <tr className="text-center" key={flight.id}>
                    <td>{flight.id}</td>
                    <td>{flight.flight_report_id}</td>
                    <td>{flight.departure_location.icao_code}</td>
                    <td>{flight.arrival_location.icao_code}</td>
                    <td>{flight.engine_start_time_str}</td>
                    <td>{flight.takeoff_time_str}</td>
                    <td>{flight.landing_time_str}</td>
                    <td>{flight.engine_shutoff_time_str}</td>
                    <td>{flight.night_time_str}</td>
                    <td>{flight.ifr_time_str}</td>
                    <td>{flight.day_landings + flight.night_landings}</td>
                    <td>{flight.takeoff_landing_time_str}</td>
                    <td>{flight.total_time_str}</td>
                    <td>{flight.fuel_start}</td>
                    <td>{flight.fuel_end}</td>
                    <td>{flight.pax + flight.flight_report_leg_staffs.length}</td> {/* PAX + Tripulação */}
                    <td>{flight.payload}</td>
                    <td>{flight.external_load_time}</td>
                    <td>{flight.external_load_cycles}</td>
                    <td>{flight.flight_report.flight_type.anac_code}</td>
                    {Object.keys(self.state.aircraft_model_version_custom_items).length > 0 && Object.keys(flight.flight_report_leg_custom_items).length > 0 ?
                      Object.keys(flight.flight_report_leg_custom_items).map(function(k) {
                        var custom_item = flight.flight_report_leg_custom_items[k];
                        return(
                          <td>
                            {custom_item.value}
                          </td>
                        );
                      })

                      : Object.keys(self.state.aircraft_model_version_custom_items).length > 0 ?
                        Object.keys(self.state.aircraft_model_version_custom_items).map(function(k) {
                        return(
                          <td></td>
                        );
                      })

                      :
                      ''
                    }
                    {
                      (self.state.aircraft.hums == 1) ?
                      <td>{flight.hums_status}</td>
                      :
                      ''
                    }
                    {
                      (self.state.aircraft.hums == 1) ?
                      <td>{flight.hums_confirmed_str}</td>
                      :
                      ''
                    }
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      </div>
    );
  }
}

export default AircraftLogbookFlightsTab;


// WEBPACK FOOTER //
// ./src/Components/AircraftLogbooks/Elements/AircraftLogbookFlightsTab.js